"use strict"


import * as config from "../framework/config";
import {format, optional} from "./lang";
import {addToken} from "../api/utils";
import {ALERT_WARNING, hideLoader, showLoader, swal} from "../plugins";
import * as _ from "underscore";
import M from "../strings";
import deepmerge from "deepmerge";

export function navigateToHref(href) {
    location.href = href;
    scrollOnTop()
}

export function scrollOnTop() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
}

export function collectionUnion() {
    var args = Array.prototype.slice.call(arguments);
    var it = args.pop();

    return _.uniq(_.flatten(args, true), it);
}

export function downloadFile(path, filename, options) {

    if (!options)
        options = {};

    let url = config.get("attachment.download") + "?path=" + path + "&filename=" + optional(filename, "");
    //window.open(url)


    if (!options.callback) {
        options.callback = (base64String, filename, mimetype) => {
            //Utilizza il plugin theme/vendors/download/download.js
            download(base64String, filename, mimetype);
        }
    }

    getFileFromUrl(url, options.callback, options.showLoader);
}

export function downloadFileFromUrl(url) {
    showLoader();
    $.ajax({
        url: url,
        method: "GET",
        headers: addToken({}),
        dataType: "text",
        //accept: accept == null ? undefined : accept,
        //contentType: contentType == null ? undefined : contentType,
        success: function(response) {

            let rsp = JSON.parse(response);

            //Utilizza il plugin theme/vendors/download/download.js
            download(rsp.base64String, rsp.filename, rsp.mimeType);
            hideLoader()
        },
        error: function(xhr, err) {
            hideLoader()
        }
    })

}



export function performAndComplete(options = {}) {
    let title = optional(options.title, M("confirm"))
    let text =  optional(options.text, M("confirm"))
    let showCancelButton = optional(options.showCancelButton, true)
    let type = options.type || ALERT_WARNING
    let confirmCallback = options.confirmCallback
    let cancelCallback = options.cancelCallback

    swal({title: title, text: text, showCancelButton: showCancelButton , type: type})
        .then(res => {
            if (res.value) {
               if (_.isFunction(confirmCallback))
                   confirmCallback()
            } else {
                if (_.isFunction(cancelCallback))
                    cancelCallback()
            }
        })

}



function getFileFromUrl(url, callback, showLoader) {
    if (showLoader)
        showLoader();
    let headers = addToken({});
    $.ajax({
        url: url,
        method: "GET",
        headers: addToken({}),
        dataType: "text",
        beforeSend: request => {
            if (_.isObject(headers)) {
                _.keys(headers).forEach(k => {
                    logger.i("Adding header:", k + "=" + headers[k])
                    request.setRequestHeader(k, headers[k])
                })
            }
        },

        //accept: accept == null ? undefined : accept,
        //contentType: contentType == null ? undefined : contentType,
        success: function(response) {

            let rsp = JSON.parse(response);
            callback(rsp.base64String, rsp.filename, rsp.mimeType)
            if (showLoader)
                hideLoader();
        },
        error: function(xhr, err) {
            if (showLoader)
                hideLoader();
        }

    })

}

export function isInViewport(element, boundingBox = false) {
    const {left, right, top, bottom} = element.getBoundingClientRect(),
        windowHeight = window.innerHeight,
        windowWidth = window.innerWidth;

    let elementInViewport;

    if (boundingBox) {
        elementInViewport = top >= 0 &&
            left >= 0 &&
            bottom <= windowHeight &&
            right <= windowWidth;
    } else {
        elementInViewport = 
            top <= windowHeight &&
            bottom >= 0 &&
            left <= windowWidth &&
            right >= 0;
    }

    return elementInViewport
}

export function isInElement(childElement, parentElement, boundingBox = false) {
    const childRect = childElement.getBoundingClientRect(),
        parentRect = parentElement.getBoundingClientRect();

    let childInParent;

    if (boundingBox) {
        childInParent = childRect.top >= parentRect.top &&
            childRect.left >= parentRect.left &&
            childRect.bottom <= parentRect.bottom &&
            childRect.right <= parentRect.right;
    } else {
        childInParent = childRect.top <= parentRect.bottom &&
            childRect.bottom >= parentRect.top &&
            childRect.left <= parentRect.right &&
            childRect.right >= parentRect.left;
    }

    return childInParent
}

export function deepClone(object) {
    return deepmerge({},object);
}

export function arrayMoveImmutable(array, oldIndex, newIndex){
    const items = [...optional(array, [])],
        [item] = items.splice(oldIndex, 1);
    items.splice(newIndex, 0, item);
    return items
}